import { render, staticRenderFns } from "./two-factor-auth-email-sent.vue?vue&type=template&id=5264b7eb&"
import script from "./two-factor-auth-email-sent.vue?vue&type=script&lang=js&"
export * from "./two-factor-auth-email-sent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports